<!-- 作为token登录的过渡页面，页面loading ,登录后 跳转到首页 ， 如果登录失败，则跳转到登录页面 -->
<template>
  <div class="login-token-container">
    <div class="loading-wrapper">
      <div class="loading-spinner"></div>
      <div class="loading-text">正在登录中...</div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'
export default {
  name: 'LoginToken',
  data () {
    return {
      loading: true
    }
  },
  mounted () {
    const token = this.$route.query.t
    if (token) {
      this.handleTokenLogin(token)
    }
  },
  methods: {
    ...mapActions(['getLoginToken']),

    handleTokenLogin (token) {
      try {
        this.getLoginToken({ loginParams: { token }, isSaveStorage: true })
          .then(() => {
            this.loginSuccess()
          })
          .catch(err => {
            this.showLoginErrorInfo = (err.msg || JSON.stringify(err))
          })
      } catch (error) {
        console.log(error)
      }
    },

    loginSuccess (res) {
      // this.$router.push({ path: '/' })
      // 通过这里的传参 来得知是否点击自动登录按钮
      this.$router.push({ path: '/', query: { isAutoLogin: this.isAutoLogin } })
      // 延迟 1 秒显示欢迎信息
      setTimeout(() => {
        this.$notification.success({
          message: '欢迎',
          description: `${timeFix()}，欢迎回来`
        })
      }, 1000)
      this.showLoginErrorInfo = ''
    }
  }
}
</script>

<style lang="less" scoped>
.login-token-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100vw;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.loading-wrapper {
  text-align: center;
  color: white;
}

.loading-spinner {
  width: 50px;
  height:50px;
  border: 4px solid rgba(255,255,255,0.3);
  border-top: 4px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

.loading-text {
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 1px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
